const getPercentSize = (originalSize: string, percentSize: number): string => {
  const sizeValue: number = parseFloat(originalSize);

  if (!Number.isNaN(sizeValue) && originalSize.trim() !== '') {
    const sizeUnit: string = originalSize.replace(sizeValue.toString(), '').trim();
    const newSizeValue: number = Math.ceil(sizeValue * percentSize);
    return `${newSizeValue}${sizeUnit}`;
  }
  return originalSize;
};

export default getPercentSize;
